import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  CButton,
  CCol,
  CCollapse,
  CFormLabel,
  CFormSelect,
  CFormText,
  CModal,
  CRow,
  CSpinner,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import '../cms/content.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
// import { isEmpty } from '../../utils/helper'
import { LANGUAGES } from 'src/views/utils/constants'
import { multipleSignedUrl } from 'src/s3upload/upload-multiple-file'
import { attachAssetsAction } from '../../../Redux/Actions/assetAction'
import { isEmpty } from 'lodash'

const OptionsModal = ({ showModal, selectedAsset, type }) => {
  const dispatch = useDispatch()
  const customerId = localStorage.getItem('customer_id')

  const [dynamicFields, setDynamicFields] = useState([{ language: '', fileObj: {} }])

  // const [errorData, setErrorData] = useState({})

  const [collapseToggle, setCollapseToggle] = useState(false)

  const [submitLoading, setSubmitLoading] = useState(false)

  const fileType = selectedAsset.file_metadata.file_type
  const attached_audio = selectedAsset.attached_audio || []
  const attached_srt = selectedAsset.attached_srt || []

  let handleChange = (i, e) => {
    let temp = [...dynamicFields]
    if (e.target.name === 'language') {
      temp[i].language = e.target.value
    } else {
      temp[i].fileObj = e.target.files[0]
    }
    setDynamicFields(temp)
  }

  let addFormFields = () => {
    setDynamicFields([...dynamicFields, { language: '', fileObj: {} }])
  }

  let removeFormFields = (i) => {
    let temp = [...dynamicFields]
    temp.splice(i, 1)
    setDynamicFields(temp)
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {
      language: '',
      fileObj: '',
    }

    for (let index = 0; index < dynamicFields.length; index++) {
      const element = dynamicFields[index]

      if (element.language.trim().length === 0) {
        isFormValid = false
        temp.language = 'Select Language!'
      }
      if (!element.fileObj?.name) {
        isFormValid = false
        temp.fileObj = 'Choose file!'
      }
    }

    // setErrorData({ ...temp })
    return isFormValid
  }

  const handleSubmit = async () => {
    if (!validateInfo()) return
    setSubmitLoading(true)
    let tempFiles = []
    let tempLanguages = []
    for (let index = 0; index < dynamicFields.length; index++) {
      const element = dynamicFields[index]

      element.fileObj[`fileType`] = 'other'
      tempFiles.push(element.fileObj)
      tempLanguages.push(element.language)
    }
    const res = await multipleSignedUrl(tempFiles, customerId, tempLanguages)

    if (res.success) {
      let requestObj = {
        transcode_type: type,
        asset_id_list: res.completedAssets,
      }

      const attachResponse = await dispatch(
        attachAssetsAction(requestObj, customerId, selectedAsset.asset_id),
      )

      if (attachResponse?.success) {
        setSubmitLoading(false)
        setDynamicFields([{ language: '', fileObj: {} }])
        showModal(false)
      } else {
        setSubmitLoading(false)
        setDynamicFields([{ language: '', fileObj: {} }])
        showModal(false)
      }

      // console.log('attachResponse', attachResponse)
    }
  }

  function existingFiles() {
    let temp = type === 'SRT' ? attached_srt : attached_audio
    const upperPart = temp
      .filter((info, index) => index < 3)
      .map((info, index) => (
        <CRow key={index} className="mt-1">
          <CCol xs="3">
            <p>{LANGUAGES.find((element) => info.file_metadata.language === element.code).name}</p>
          </CCol>
          <CCol>
            <p>{info.file_name}</p>
          </CCol>
        </CRow>
      ))

    const lowerPart = temp
      .filter((info, index) => index > 2)
      .map((info, index) => (
        <CRow key={index} className="mt-1">
          <CCol xs="3">
            <p>{LANGUAGES.find((element) => info.file_metadata.language === element.code).name}</p>
          </CCol>
          <CCol>
            <p>{info.file_name}</p>
          </CCol>
        </CRow>
      ))
    return (
      <>
        {upperPart}
        <CCollapse visible={collapseToggle}>{lowerPart}</CCollapse>
      </>
    )
  }

  const handleCancel = () => {
    setDynamicFields([{ language: '', fileObj: {} }])
    showModal(false)
  }
  return (
    <>
      <CModal
        alignment={submitLoading ? 'center' : 'top'}
        scrollable
        size={submitLoading ? 'sm' : 'lg'}
        visible="true"
      >
        {submitLoading ? (
          <div style={{ textAlign: 'center' }} className="subtitle-modal-div">
            <p>Uploading...</p>
            <CSpinner color="info" />
          </div>
        ) : (
          <div className="subtitle-modal-div">
            <CFormLabel>
              <b>
                Upload {type === 'SRT' ? 'subtitle' : 'audio'} for
                {fileType === 'AUDIO' ? ' audio' : ' video'} {`'${selectedAsset.file_name}'`}
              </b>
            </CFormLabel>
            <p className="mt-2">
              List of {type === 'SRT' ? 'subtitle' : 'audio'} already added to this{' '}
              {fileType === 'AUDIO' ? ' audio' : ' video'} :
            </p>
            <SimpleBar
              forceVisible="y"
              style={{ maxHeight: 500, overflowX: 'hidden' }}
              autoHide={false}
            >
              <CRow className="mt-2">
                <CCol xs="3">
                  <b>LANGUAGE</b>
                </CCol>
                <CCol>
                  <b>FILE NAME</b>
                </CCol>
              </CRow>
              {(!isEmpty(attached_audio) && type === 'AUDIO') ||
              (!isEmpty(attached_srt) && type === 'SRT') ? (
                existingFiles()
              ) : (
                <CRow className="mt-1">
                  <CCol xs="3">
                    <p>No Data Found</p>
                  </CCol>
                  <CCol />
                </CRow>
              )}
              {(attached_audio.length > 3 && type === 'AUDIO') ||
              (attached_srt.length > 3 && type === 'SRT') ? (
                <h6 onClick={() => setCollapseToggle(!collapseToggle)}>
                  {collapseToggle ? 'less' : 'more'}...
                </h6>
              ) : null}

              {dynamicFields.map((element, index) => (
                <CRow className="mt-5" key={index}>
                  <CCol xs="4">
                    {!index ? (
                      <p>
                        <b>Add {type === 'SRT' ? 'Subtitle' : 'Audio'} </b>
                      </p>
                    ) : null}

                    <CFormSelect
                      size="sm"
                      value={element.language}
                      name="language"
                      onChange={(e) => handleChange(index, e)}
                      placeholder="Language"
                    >
                      <option value="" selected disabled>
                        Language
                      </option>
                      {LANGUAGES.map((info, index) => (
                        <option
                          key={index}
                          value={info.code}
                        >{`${info.name} (${info.nativeName})`}</option>
                      ))}
                    </CFormSelect>
                  </CCol>
                  <CCol
                    style={{
                      justifyContent: 'center',
                      display: 'flex',
                      alignItems: 'flex-end',
                    }}
                    xs={!index ? '4' : '5'}
                  >
                    <input
                      type="file"
                      name="fileObj"
                      accept={type === 'SRT' ? '.vtt' : '.mp3,audio/*'}
                      onChange={(e) => handleChange(index, e)}
                    />
                    {index ? (
                      <CIcon
                        icon={cilTrash}
                        style={{ color: 'red', cursor: 'pointer' }}
                        size="xl"
                        onClick={() => removeFormFields(index)}
                      />
                    ) : null}
                  </CCol>
                  {!index ? (
                    <CCol>
                      <CFormText>
                        {type === 'SRT'
                          ? `Subtitles must be in valid VTT format media type, such as text/vtt. Max file
                        size : 3 MB`
                          : `Audio must be in valid Mp3 format media type, such as Mp3/wav. Max file
                          size : 100 MB`}
                      </CFormText>
                    </CCol>
                  ) : null}
                </CRow>
              ))}
            </SimpleBar>
            <CRow className="mt-3">
              <CCol xs="3" style={{ color: '#1976d2', cursor: 'pointer' }} onClick={addFormFields}>
                <FontAwesomeIcon style={{ marginRight: '0.9rem' }} icon={faPlusCircle} size="lg" />
                Add more {type === 'SRT' ? 'Subtitle' : 'Audio'}
              </CCol>
              <CCol />
            </CRow>
            <div className="mt-4 d-md-flex justify-content-md-end">
              <CButton
                style={{ marginRight: '2rem' }}
                className="text-white"
                color="info"
                onClick={handleSubmit}
              >
                Submit
              </CButton>
              <h6 onClick={handleCancel}>Cancel</h6>
            </div>
          </div>
        )}
      </CModal>
    </>
  )
}

export default OptionsModal
